import type React from 'react';

import { IconButton, Menu, MenuItem } from '@coop/components';
import { XIcon } from '@coop/icons';
import { useState } from 'react';
import { MenuTrigger, Popover } from 'react-aria-components';

import type { ProfilePopoverItem } from './HeaderProfilePopover.types';

import useModal from '../../../../common/hooks/useModal';
import { FlyInType } from '../../../../common/store/structureDefinitions/modalState';
import { ga4NavigationTracking } from '../../../../common/tracking/ga4/navigation';
import { useIsDarkMode } from '../../../../ecommerce/hooks/useIsDarkMode';
import useReactRouting from '../../../../ecommerce/hooks/useReactRouting';

const HeaderProfilePopover = (props: {
    items: ProfilePopoverItem[];
    label: string;
    icon: React.ComponentProps<typeof IconButton>['icon'];
}) => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const { open } = useModal(FlyInType.MyProfileMenu);
    const isDarkMode = useIsDarkMode();
    const { push } = useReactRouting();

    const handleTriggerClick = (_isOpen: boolean) => {
        if (_isOpen) {
            setIsPopoverOpen(true);
            ga4NavigationTracking.savedItems.open();
        } else {
            setIsPopoverOpen(false);
            ga4NavigationTracking.savedItems.close();
        }
    };

    const handleListItemClick = (href: string, item: ProfilePopoverItem) => {
        ga4NavigationTracking.savedItems.click(item.name, href);
        push(href, true);
    };

    return (
        <MenuTrigger onOpenChange={handleTriggerClick}>
            <IconButton
                theme={isDarkMode ? 'outlined-inverse' : 'outlined-subtle'}
                label={props.label}
                icon={isPopoverOpen ? <XIcon /> : props.icon}
            />
            <Popover placement="bottom">
                <Menu selectionMode="single">
                    {props.items.map((item) => (
                        <MenuItem
                            key={item.name}
                            id={item.name}
                            icon={item.icon}
                            onAction={() => {
                                if (item.type === 'button' && item.id === 'myProfile') {
                                    open();
                                    return;
                                }

                                handleListItemClick(item.url, item);
                            }}
                        >
                            {item.name}
                        </MenuItem>
                    ))}
                </Menu>
            </Popover>
        </MenuTrigger>
    );
};

export default HeaderProfilePopover;
